import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
import * as actions from "../../../../Redux/actions";
import Select from "react-select";
import { MultiiSelectDropdown } from "./MultiiSelectDropdown";

const GeneralSetting = (params) => {
  const orderSettingReducer = useSelector((state) => state.orderSettingReducer);
  // ///////////

  const [tradeRecipients, setTradeRecipients] = useState([]);
  const [nonTradeRecipients, setNonTradeRecipients] = useState([]);

  const [selectedOptions, setSelectedOptions] = useState({
    order_management_type: 1,
    order_amount_logic: 0,
    billing_address_merchant_id: 0,
    inherit_account_ids: ["2"],
    trade_order_recipients: null,
    nontrade_order_recipients: null,
  });

  useEffect(() => {
    // extracting values because Mohit API theek ni banata
    const tradeRecipientsValues = tradeRecipients.map((el) => el.value);
    const nonTradeRecipientsValues = nonTradeRecipients.map((el) => el.value);
    console.log(tradeRecipientsValues);
    setSelectedOptions({
      ...selectedOptions,
      ...{ trade_order_recipients: tradeRecipientsValues },
      ...{ nontrade_order_recipients: nonTradeRecipientsValues },
    });
  }, [tradeRecipients, nonTradeRecipients]);
  console.log(selectedOptions, "selectedOptions");
  // /////////////
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(actions.getOrderSettings(orderSettingReducer.accounts));
  }, []);

  function handleOptions(selectedOption, recipients, setRecipients) {
    const selectAll = selectedOption.find((option) => option.value === 0);
    if (selectAll) {
      recipients?.length === orderSettingReducer.recipients.length - 1
        ? setRecipients([])
        : setRecipients(orderSettingReducer.recipients.slice(1));
    } else setRecipients(selectedOption);
  }

  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content row mx-0 order-general-settings chart-of-accounts">
          <div className="container px-0">
            <div className="row orderManagementSetting d-flex">
              <div className="col-md-12">
                <div className="shadowclass d-flex flex-wrap align-content-start">
                  <h4 className="event-alert w-100">Order Management Type</h4>
                  <div className="d-flex w-100 pt-0">
                    <ul class="mgt-type col-12">
                      <li>
                        <div class="col-set">
                          <div class="none-sec">
                            <h4>None</h4>
                            <article>
                              <p>
                                By selecting this option, all Order Management
                                and its timesaving benefits will not be
                                available to the user.
                              </p>
                              <br />
                              <div class="listing">
                                <p>
                                  More manual amount entries into the Finance
                                  module increase the account’s susceptibility
                                  to risk.
                                </p>
                                <p>
                                  Lose ability to see MTD Purchase Amounts for
                                  individual Inventory Items when using None or
                                  Physical Only Inventory Management Types
                                  (would only see monthly total supplier
                                  expenses).
                                </p>
                              </div>
                            </article>
                          </div>
                          <div class="radio-cust">
                            <input
                              type="hidden"
                              name="data[OrderGeneralSetting][id]"
                              value="268"
                              id="OrderGeneralSettingId"
                            />{" "}
                            <input
                              type="radio"
                              name="data[OrderGeneralSetting][order_management_type]"
                              id="orderGeneralSettingOrderManagementType0"
                              disabled="disabled"
                              value="0"
                            />
                            <label for="orderGeneralSettingOrderManagementType0">
                              0
                            </label>{" "}
                          </div>
                        </div>
                      </li>

                      <li>
                        <div class="col-set">
                          <div class="none-sec">
                            <h4>Order Management</h4>
                            <article>
                              <p>
                                One of the top time-savers of the system, Order
                                Management allows users to streamline their
                                Order process and leverage the strong
                                connectivity between the Inventory module and
                                the Finance Module. This functionality is HIGHLY
                                RECOMMENDED.
                              </p>
                              <br />
                              <div class="listing">
                                <p>
                                  Once an order has been delivered successfully
                                  and confirmed in the system, inventory amounts
                                  will be updated and an expense will be
                                  auto-generated requiring only payment type
                                  entry and a simple confirmation, thereby
                                  saving further time and reducing manual data
                                  entry risk.
                                </p>
                                <p>
                                  Gain ability to see MTD Purchase Amounts for
                                  individual Inventory Items when using None or
                                  Physical Only Inventory Management Types.
                                </p>
                              </div>
                            </article>
                          </div>
                          <div class="radio-cust">
                            <input
                              type="radio"
                              name="data[OrderGeneralSetting][inventory_management_type]"
                              id="InventoryGeneralSettingInventoryManagementType2"
                              value="1"
                              checked
                            />
                            <label
                              onClick={() =>
                                setSelectedOptions({
                                  ...selectedOptions,
                                  order_management_type: 1,
                                })
                              }
                              for="InventoryGeneralSettingInventoryManagementType2"
                            >
                              1
                            </label>{" "}
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="row orderAmountLogicSec d-flex">
              <div className="col-md-12">
                <div className="shadowclass d-flex flex-wrap align-content-start">
                  <h4 className="event-alert w-100">Order Amount Logic</h4>
                  <div className="d-flex w-100 pt-0">
                    <ul class="mgt-type col-12">
                      <li>
                        <div class="col-set">
                          <div class="none-sec">
                            <h4>None</h4>
                            <article>
                              <p>
                                This selection will require full manual order
                                amount entry in the Order sheets with no preset
                                amounts or recommendations..
                              </p>
                            </article>
                          </div>
                          <div class="radio-cust">
                            <input
                              type="radio"
                              name="data[OrderGeneralSetting][expected_inventory_calculation]"
                              id="OrderGeneralSettingExpectedOrderCalculation1"
                              value="0"
                              checked="checked"
                            />
                            <label
                              onClick={() =>
                                setSelectedOptions({
                                  ...selectedOptions,
                                  order_amount_logic: 0,
                                })
                              }
                              for="OrderGeneralSettingExpectedOrderCalculation1"
                            >
                              0
                            </label>{" "}
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="col-set">
                          <div class="none-sec">
                            <h4>Trigger-Based Fixed Order Amounts</h4>
                            <article>
                              <p style={{ marginBottom: "15px" }}>
                                Enables the system to leverage the Par-Value
                                Stock Level and Re-Stock Threshold Level fields
                                to save time during the order management by
                                populating preset inventory item order levels in
                                the order sheets when given minimum stock
                                thresholds are passed.
                              </p>
                              <h6>Not available in the initial release</h6>
                            </article>
                          </div>
                          <div class="radio-cust">
                            <input
                              type="radio"
                              name="data[OrderGeneralSetting][expected_order_calculation]"
                              id="OrderGeneralSettingExpectedOrderCalculation2"
                              value="2"
                              disabled
                            />
                            <label
                              onClick={() =>
                                dispatch(
                                  actions.showNotificationWithTimeout(
                                    `This feature isn't available in the initial release`,
                                    "error"
                                  )
                                )
                              }
                              for="OrderGeneralSettingExpectedOrderCalculation2"
                            >
                              2
                            </label>{" "}
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="col-set">
                          <div class="none-sec">
                            <h4>Predictive Model</h4>
                            <article>
                              <p style={{ marginBottom: "15px" }}>
                                This is an advanced statistical model taking
                                into account all historical sales data to help
                                determine accurate stock needs for any given
                                period to ensure optimized inventory levels.
                              </p>
                              <h6>Not available in the initial release</h6>
                            </article>
                          </div>
                          <div class="radio-cust">
                            <input
                              type="radio"
                              name="data[OrderGeneralSetting][expected_order_calculation]"
                              id="OrderGeneralSettingExpectedOrderCalculation3"
                              value="3"
                              disabled
                            />
                            <label
                              onClick={() =>
                                dispatch(
                                  actions.showNotificationWithTimeout(
                                    `This feature isn't available in the initial release`,
                                    "error"
                                  )
                                )
                              }
                              for="OrderGeneralSettingExpectedOrderCalculation3"
                            >
                              3
                            </label>{" "}
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="row employeeSettingSec d-flex">
              <div className="col-md-12">
                <div className="shadowclass d-flex flex-wrap align-content-start inevt-step-deatil product-sheet">
                  <div id="pre" class="w-100">
                    <div>
                      <h4 className="event-alert w-100">
                        Order Communications Settings
                      </h4>
                      <ul className="orderCommunications">
                        <li>
                          <div class="none-sec">
                            <h5 className="event-alert w-100 border-bottom-0">
                              Order Billing Address
                            </h5>
                            <article>
                              <div class="listing">
                                <div class="input-group select-div d-inline-block">
                                  <div class="input select">
                                    <select
                                      name="data[InventoryOrderSetting][billing_address_merchant_id]"
                                      required="required"
                                      id="InventoryOrderSettingBillingAddressMerchantId"
                                      class="valid"
                                      // value="0"
                                      onChange={() => {
                                        const selectedAddress =
                                          document.querySelector(
                                            "#InventoryOrderSettingBillingAddressMerchantId"
                                          ).value;
                                        setSelectedOptions({
                                          ...selectedOptions,
                                          billing_address_merchant_id:
                                            selectedAddress,
                                        });
                                      }}
                                    >
                                      <option
                                        onClick={() => {
                                          console.log(
                                            "address",
                                            selectedOptions
                                          );
                                        }}
                                        value="0"
                                      >
                                        Select
                                      </option>
                                      {orderSettingReducer?.accounts?.map(
                                        (el) => (
                                          <option value={el.value}>
                                            {el.label}
                                          </option>
                                        )
                                      )}
                                    </select>
                                  </div>{" "}
                                </div>
                              </div>
                            </article>
                          </div>
                        </li>
                        <li>
                          <h5 className="event-alert w-100 border-bottom-0">
                            Trade Order PO Recipients
                          </h5>
                          <article>
                            <div class="listing">
                              <Select
                                isMulti
                                closeMenuOnSelect={false}
                                value={tradeRecipients}
                                options={orderSettingReducer.recipients}
                                onChange={(selectedOption) => {
                                  handleOptions(
                                    selectedOption,
                                    tradeRecipients,
                                    setTradeRecipients
                                  );
                                }}
                              />
                            </div>
                          </article>
                        </li>
                        <li>
                          <h5 className="event-alert w-100 border-bottom-0">
                            Non Trade Order PO Recipients
                          </h5>
                          <article>
                            <div class="listing">
                              <Select
                                isMulti
                                closeMenuOnSelect={false}
                                value={nonTradeRecipients}
                                options={orderSettingReducer.recipients}
                                onChange={(selectedOption) => {
                                  handleOptions(
                                    selectedOption,
                                    nonTradeRecipients,
                                    setNonTradeRecipients
                                  );
                                }}
                              />
                            </div>
                          </article>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mx-0">
          <div class="container px-0 d-flex col-12">
            <div class="btns col-4 d-flex justify-content-end py-4 col-12">
              <button
                onClick={() => {
                  console.log(selectedOptions);
                  dispatch(actions.postOrderSettings(selectedOptions));
                }}
                id=""
                type="Submit"
              >
                Save
              </button>
              <button id="cancel" type="button">
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default GeneralSetting;
